import { NaturezaOperacaoListStruct } from '@shared/services/structs/motor-fiscal/natureza-operacao-list.struct';
import { TipoPadraoNaturezaOperacaoStruct } from '@shared/services/structs/motor-fiscal/tipo-padrao-natureza-operacao.struct';

export class TornarPadraoDialogData {
    natureza: NaturezaOperacaoListStruct;
    tiposPadrao: TipoPadraoNaturezaOperacaoStruct[];
}
